export const setProperty = (el, name, value, callback) => {
  const props = el ? (el.props ? el.props : el) : null;

  if (props && props.mounted()) {
    props[`set${name.charAt(0).toUpperCase()}${name.slice(1)}`](
      value,
      callback
    );
  }
};
